module.exports = __webpack_public_path__ + "img/travel-expenses-icon.f108871f.svg";